
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateStepMailSettingMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createStepMailSetting"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateStepMailSettingInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createStepMailSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"stepMailSettingInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createStepMailSetting"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenpo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"send_timing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"send_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"body"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"buy_property_search_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created_user"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receive_open_notification_mail_flg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stepMailSettingBuyPropertyTypes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"step_mail_setting"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"buy_property_type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stepMailSettingClientRanks"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"step_mail_setting_client_rank"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"step_mail_setting"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"client_rank"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stepMailSettingAnkenOndos"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"step_mail_setting_anken_ondo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"step_mail_setting"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anken_ondo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stepMailSettingAnkenStatuses"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"step_mail_setting"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anken_status"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stepMailFiles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"step_mail_setting"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"object_key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"file_name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stepMailSellReasons"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sell_reason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"step_mail_setting"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"shopRelation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shop"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":986}};
    doc.loc.source = {"body":"mutation CreateStepMailSettingMutation($createStepMailSetting: CreateStepMailSettingInput!){\n  createStepMailSetting(stepMailSettingInput: $createStepMailSetting){\n    tenpo\n    name\n    id\n    status\n    send_timing\n    send_time\n    type\n    title\n    body\n    buy_property_search_type\n    created_user\n    receive_open_notification_mail_flg\n    stepMailSettingBuyPropertyTypes {\n      id\n      step_mail_setting\n      buy_property_type\n    }\n    stepMailSettingClientRanks {\n      step_mail_setting_client_rank\n      step_mail_setting\n      client_rank\n    }\n    stepMailSettingAnkenOndos {\n      step_mail_setting_anken_ondo\n      step_mail_setting\n      anken_ondo\n    }\n    stepMailSettingAnkenStatuses {\n      id\n      step_mail_setting\n      anken_status\n    }\n    stepMailFiles {\n      id\n      step_mail_setting\n      object_key\n      file_name\n    }\n    stepMailSellReasons {\n      id\n      sell_reason\n      step_mail_setting\n    }\n    shopRelation {\n      shop\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CreateStepMailSettingMutation"] = oneQuery(doc, "CreateStepMailSettingMutation");
        
